import ExpandIcon from "../assets/icons/icon-minus.svg";
import CollapseIcon from "../assets/icons/icon-plus.svg";
import CustomSpan from "../components/CustomSpan";
import React from "react";

const CollapseExpanded = (props) => {
    const {title, isExpanded, setExpanded, children} = props;

    const handleToggle = () => {
        setExpanded(!isExpanded);
    }

    return (
        <div className="inline-block">
            <div className="flex items-center gap-[8px]">
                <img src={isExpanded ? ExpandIcon : CollapseIcon} className="cursor-pointer" alt={isExpanded ? 'icon-expand' : 'icon-collapse'} onClick={handleToggle}/>
                <CustomSpan text={title} className="font-semibold text-base leading-5"/>
            </div>
            <div hidden={!isExpanded}>
                {children}
            </div>
        </div>
    );
};

export default CollapseExpanded

